<!-- DOC TYPE & SUBTYPE ______________________________________________________________________________ -->
<ng-container [formGroup]="form">
  @if (form) {
    <div class="row mt-3">
      <div class="form-group col-12" id="matter-create-subtype-container">
        <label>Subtype</label>
        <div class="input-group">
          <!-- matterSubtypeName is temporary and never stored (read comments in TS file)
          so we can't use that for requiredness. Instead we'll just add hidden field for the actual
          matterSubtypeId and that will drive requiredness. We also have to add no_auto_s_req class to the other
          input controls in this group so that they don't try to strip it out.
          -->
          <ng-template #matterSubtypeTemplate let-model="item">
            <span class="subtypePicklist">{{model.name}}</span>
          </ng-template>
          <input formControlName="matterSubtypeId" tabindex="-1" class="hidden-scrollable"
            data-validator-message-container-id="matterSubtypeValidatorContainer">
            <!-- strict: typeaheadOptionsLimit was used without brackets so it was complaining about string "101" being assigned to a number property -->
            <input #matterSubtypeInput
              id="matter-create-subtype-id"
              class="form-control no_auto_s_req s_typeahead"
              type="search"
              autocomplete="off"
              formControlName="matterSubtypeName"
              (input)="matterSubtypeSearchStarted()"
              [typeaheadOptionsLimit]="101"
              [typeaheadMinLength]="0"
              [typeahead]="subtypes"
              [typeaheadScrollable]="true"
              [typeaheadOptionsInScrollableView]="20"
              [typeaheadItemTemplate]="matterSubtypeTemplate"
              typeaheadGroupField="matterTypeName"
              typeaheadOptionField="name"
              [placeholder]="getSubtypePlaceHolder()"
              (typeaheadOnBlur)="typeAheadOnBlur($event)"
              (typeaheadOnSelect)="typeAheadValueChange($event)"
              >
            </div>
            <!-- Matter subtype  is special in a sense that it uses hidden control so we'll explicitly add and
            style the container for the message
            -->
            <div class="col-12" id="matterSubtypeValidatorContainer"></div>
          </div>
        </div>
      }
    </ng-container>